<div
    class="p-1 btn btn-info w-100 btn-info-shadow d-flex justify-content-center align-items-center"
    [ngClass]="{'disabled': disabled()}"
    (click)="navigate()">
    <ng-content/>
</div>
